<template>
  <b-row>
    <!-- Modal Filter -->
    <b-modal
      v-model="showModalFilter"
      title="Modal Filter"
      ok-title="Apply Filter"
      @ok="fetchData()"
    >
      <b-form-group label="Used For" label-for="fleet" label-cols="3">
        <v-select
          v-model="equipment.params.vehicleTypeIds"
          id="fleet"
          multiple
          placeholder="Select Vehicle Type"
          label="name"
          :options="typeFleet"
          :reduce="(opt) => opt.code"
        ></v-select>
      </b-form-group>
      <b-form-group
        label="Status"
        label-for="active"
        label-cols="3"
        class="mb-0"
      >
        <b-form-checkbox
          v-model="equipment.params.active"
          name="check-button"
          switch
          inline
        >
          <template v-if="equipment.params.active === false"> No </template>
          <template v-else>Yes</template>
        </b-form-checkbox>
      </b-form-group>
    </b-modal>

    <!-- Modal Export Import RH -->
    <b-modal
      v-model="showModalImport"
      title="Import Data"
      ok-title="Submit"
      @ok="handleImport"
    >
      <template #modal-header>
        <h5 class="text-primary">Import Data</h5>
        <i
          class="fa fa-times cursor-pointer"
          @click="showModalImport = false"
        ></i>
      </template>
      <template>
        <div class="flex flex-column align-items-center">
          <b-form-file
            v-model="importFile"
            type="file"
            class="form-control"
            accept=".xlsx, .xls, .csv"
          />
          <small class="text-black">accept: .xlsx, .xls, .csv</small>
        </div>
        <b-button
          variant="outline-primary"
          class="mt-3 w-100"
          @click="handleExport"
        >
          <i class="fa fa-download"></i> Download Template
        </b-button>
      </template>
    </b-modal>
    <!-- End Modal Export Import RH -->

    <b-col sm="12">
      <iq-card>
        <template v-slot:headerTitle>
          <h4 class="card-title text-primary">
            <strong>Vendor</strong>
          </h4>
        </template>

        <template v-slot:body>
          <div class="mb-4">
            <CustomNav :items="tabs" @item-click="(tab) => (activeTab = tab)" />
          </div>
          <div class="d-flex justify-content-between">
            <b-form class="d-flex mb-3" @submit.prevent="fetchData()">
              <b-form-input
                v-model="equipment.params.search"
                style="width: 200px"
                type="text"
                class="mr-2"
                placeholder="Search..."
              ></b-form-input>
              <b-button type="submit" variant="primary" class="ml-2">
                <i class="fa fa-search"></i>
              </b-button>
              <div>
                <b-button
                  type="button"
                  variant="outline-primary"
                  class="ml-2"
                  @click="showModalFilter = true"
                >
                  <i class="fa fa-sliders"></i> Filter Data
                </b-button>
              </div>
            </b-form>
            <div class="d-flex">
              <b-button
                variant="outline-primary"
                style="height: max-content"
                class="mr-2 d-flex align-items-center"
              >
                <i class="ri-upload-2-line pl-1"></i>Export
              </b-button>
              <template v-if="activeTab == 'candidate'">
                <b-button
                  variant="outline-primary"
                  class="d-flex align-items-center mr-2"
                  style="height: max-content"
                  @click="showModalImport = true"
                  ><i class="ri-download-2-line pl-1"></i>Import</b-button
                >
                <b-button
                  variant="primary"
                  @click="openSidebar()"
                  style="height: max-content"
                >
                  <i class="fa fa-plus mr-1"></i> New Vendor
                </b-button>
              </template>
            </div>
          </div>

          <!-- List -->
          <div class="table-responsive">
            <table class="table table-bordered table-striped">
              <thead class="thead-light">
                <tr>
                  <th v-if="activeTab == 'active'" class="text-nowrap column-1"
                    >Vendor Id</th
                  ><th
                    class="text-nowrap column-2"
                    :style="{ left: activeTab == 'active' ? '160px' : '0px' }"
                  >
                    Vendor Name
                  </th>
                  <th class="text-nowrap">Vendor Class</th>
                  <th class="text-nowrap">Vendor Category</th>
                  <th class="text-nowrap">Currency</th>
                  <th class="text-nowrap">Terms</th>
                  <th class="text-nowrap">Job Title</th>
                  <th class="text-nowrap">Pic No. Handphone</th>
                  <th class="text-nowrap">Pic Email</th>
                  <th class="text-nowrap">Country</th>
                  <th class="text-nowrap">City</th>
                  <th class="text-nowrap">Address</th>
                  <th class="text-nowrap">Address</th>
                  <th class="text-center text-nowrap" style="min-width: 100px"
                    >Status</th
                  >
                  <th class="text-center text-nowrap column-action">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in ['active', 'requested', 'blacklist']"
                  :key="index"
                >
                  <td
                    v-if="activeTab == 'active'"
                    class="text-nowrap column-1 bg-white"
                    >VND-001</td
                  >
                  <td
                    class="text-nowrap column-2 bg-white"
                    :style="{ left: activeTab == 'active' ? '160px' : '0px' }"
                    >PT. Sumber Makmur</td
                  >
                  <td class="text-nowrap">Gold</td>
                  <td class="text-nowrap">Supplier</td>
                  <td class="text-nowrap">IDR</td>
                  <td class="text-nowrap">Net 30</td>
                  <td class="text-nowrap">Manager</td>
                  <td class="text-nowrap">0812-3456-7890</td>
                  <td class="text-nowrap">manager@sumbermakmur.co.id</td>
                  <td class="text-nowrap">Indonesia</td>
                  <td class="text-nowrap">Jakarta</td>
                  <td class="text-nowrap">Jl. Merdeka No. 10</td>
                  <td class="text-nowrap">Kecamatan Gambir</td>
                  <td class="text-center">
                    <span
                      class="badge badge-pill"
                      :class="{
                        'badge-success': item === 'active',
                        'badge-warning': item === 'requested',
                        'badge-danger': item === 'blacklist',
                      }"
                      >{{ item }}</span
                    >
                  </td>
                  <td class="text-center column-action bg-white">
                    <b-dropdown
                      variant="primary"
                      size="sm"
                      text="Action"
                      right
                      class="text-center"
                    >
                      <b-dropdown-item href="#">Detail Vendor</b-dropdown-item>
                    </b-dropdown>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="mt-4 d-flex align-items-center w-100 justify-content-end">
            <b-pagination
              class="mb-0 mr-3"
              @input="fetchData"
              v-model="equipment.params.page"
              :total-rows="equipment.params.total"
              :per-page="equipment.params.limit"
              first-number
              align="center"
            ></b-pagination>
            <b-form-select
              plain
              v-model="equipment.params.limit"
              :options="limitOptions"
              style="width: 140px"
              @input="() => fetchData()"
            ></b-form-select>
          </div>
        </template>
      </iq-card>
    </b-col>

    <!-- Custom Sidebar -->
    <custom-sidebar
      v-model="showSidebar"
      size="80%"
      :title="`${equipment.editMode ? 'Edit' : 'New'} Vendor`"
    >
      <FormVendorCandidate @close="showSidebar = false" />
    </custom-sidebar>
  </b-row>
</template>

<script>
import { fleetsActions, pmsActions } from '@/src/Utils/helper'
import CustomNav from '@/src/components/global/CustomNav.vue'
import CustomSidebar from '@/src/components/global/CustomSidebar.vue'
import { limitOptions } from '@/src/core/mock/data/optionsData'
import FormVendorCandidate from '../components/FormVendorCandidate.vue'

export default {
  name: 'VendorNew',
  components: { CustomSidebar, CustomNav, FormVendorCandidate },
  data() {
    return {
      tabs: [
        {
          label: 'Vendor Active',
          value: 'active',
        },
        {
          label: 'Vendor Candidate',
          value: 'candidate',
        },
      ],
      activeTab: 'active',
      showModalImport: false,
      importFile: null,
      showModalFilter: false,
      limitOptions,
      typeFleet: [],
      equipmentParents: [],
      showSidebar: false,
      equipment: {
        editMode: false,
        params: {
          search: '',
          vehicleTypeIds: [],
          active: true,
          page: 1,
          limit: 10,
          total: 10,
          totalPages: 1,
        },
        data: [],
        form: {
          maintenance_component_id: null,
          equipment_name: '',
          description: '',
          vehicleTypeId: [],
          active: true,
        },
        detailData: null,
      },
    }
  },
  methods: {
    ...fleetsActions,
    ...pmsActions,
    async handleImport() {
      try {
        // const formData = new FormData()
        // formData.append('file', this.importFile)
        // const res = await this.importEquipment(formData)
        // this.$swal({
        //   title: 'Import Data Success',
        //   icon: 'success',
        // })
      } catch (error) {
        this.$swal({
          title: 'Failed Import Data!',
          type: 'error',
          text: 'Failed Import Data please check your file import!',
          icon: 'error',
        })
      } finally {
        this.fetchData()
      }
    },
    async handleExport() {
      try {
        // const res = await this.exportTemplateEquipment()
        // saveAs(res.data, 'template_master_equipment.xlsx')
        // this.$swal({
        //   title: 'Download Template Success',
        //   text: res.message,
        //   icon: 'success',
        // })
      } catch (error) {
        this.$swal({
          title: 'Failed Export Template',
          icon: 'error',
        })
      }
    },
    openSidebar(data) {
      this.showSidebar = true
      if (data) {
        this.equipment.editMode = true
        this.equipment.detailData = data
        this.equipment.form = {
          maintenance_component_id: data.maintenance_component_id,
          equipment_name: data?.equipment_name,
          description: data.description,
          vehicle_type_ids: data.maintenance_component_vehicle_types?.map(
            (el) => el?.vehicle_type_id
          ),
          active: data.active,
        }
      } else {
        this.equipment.editMode = false
        this.equipment.detailData = null
        this.equipment.form = {
          maintenance_component_id: null,
          equipment_name: '',
          description: '',
          vehicle_type_ids: [],
          active: true,
        }
      }
    },

    closeSidebar() {
      this.showSidebar = false
    },

    async getVehicleTypeData() {
      const res = await this.getFleetTypes()

      if (res.status === 'success' && Array.isArray(res.data)) {
        // langsung assign data yg aktif
        this.typeFleet = res.data
          .filter((item) => item.active)
          .map((element) => ({
            name: element.name,
            color:
              element.name === 'Tugboat'
                ? 'success'
                : element.name === 'Barge'
                ? 'warning'
                : 'primary',
            code: element.id,
          }))
      } else {
        this.$swal(`Oops!`, res.data, 'error')
      }
    },

    async fetchData(page = 1) {
      const res = await this.getEquipment({
        ...this.equipment.params,
        page,
        vehicleTypeId: this.equipment.params.vehicleTypeIds?.toString(),
      })
      console.log('data', res.data.data)

      if (res.status === 'success') {
        this.equipment.data = res.data.data
        this.equipment.params = {
          ...this.equipment.params,
          ...res.data.pagination,
        }
      } else {
        this.$swal(`Oops!`, res.data, 'error')
      }
    },

    async fetchDataCategory() {
      const params = {
        limit: 9999,
        page: 1,
      }
      const res = await this.getEquipment(params)
      if (res.status === 'success') {
        const filteredData = res.data.data
        console.log({ filteredData })

        this.equipmentParents = filteredData
      } else {
        this.$swal(`Oops!`, res.data, 'error')
      }
    },

    async handleSubmit() {
      if (this.equipment.form.maintenance_component_id) {
        this.equipment.form.maintenance_component_id = Number(
          this.equipment.form.maintenance_component_id
        )
      }

      this.$swal.fire({
        title: 'Processing...',
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          swal.showLoading()
        },
      })

      if (this.equipment.editMode) {
        const res = await this.updateEquipment({
          id: this.equipment.detailData.id,
          data: this.equipment.form,
        })
        if (res.status === 'success') {
          this.$swal('Update Success!', res.data.message, 'success')
          this.fetchData()
          this.showSidebar = false
        } else {
          this.$swal(`Oops!`, res.data.message, 'error')
        }
      } else {
        const body = {
          ...this.equipment.form,
          alias: this.equipment.form.equipment_name
            .toLowerCase()
            .replace(' ', '_'),
        }
        const res = await this.createEquipment(body)
        if (res.status === 'success') {
          this.$swal('Add Success!', res.data.message, 'success')
          this.fetchData()
          this.showSidebar = false
        } else {
          this.$swal(`Oops!`, res.data.message, 'error')
        }
      }
    },

    deleteItem(dataVal) {
      this.$swal({
        title: 'Delete Equipment Category?',
        text: `${dataVal.text} will be deleted and cannot be recovered.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Delete',
      }).then(async (result) => {
        if (result.isConfirmed) {
          let res = await this.deleteEquipment(dataVal.id)
          if (res.status === 'success') {
            this.fetchData()
            this.$swal(
              `Deleted!`,
              `Equipment Category ${dataVal.equipment_name} successfully deleted`,
              'success'
            )
          } else {
            this.$swal('Error', res.data.message || 'Server error', 'error')
          }
        }
      })
    },
  },
  mounted() {
    this.getVehicleTypeData()
    this.fetchData()
    this.fetchDataCategory()
  },
}
</script>

<style scoped>
.column-1 {
  min-width: 160px;
  position: sticky;
  left: 0;
}
.column-2 {
  width: 200px;
  position: sticky;
  left: 160px;
}
.column-action {
  min-width: 160px;
  position: sticky;
  right: 0px;
}
</style>
